export default "__VITE_ASSET__B8c1Nn0M__"